import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  triggerButtonClick () {
    if (this.element.disabled) {
      return
    }

    this.#triggerClick()
  }

  #triggerClick() {
    this.element.click()
  }
}
